import { AO_PACKAGE_DETAILS_FAILURE, AO_PACKAGE_DETAILS_REQUEST, AO_PACKAGE_DETAILS_SUCCESS } from "../../actions";
const initialState = {
    data: null,
    result: null,
    loading: false,
    error: null,
};
const addOrderPackageDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case AO_PACKAGE_DETAILS_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, result: action.payload });
        case AO_PACKAGE_DETAILS_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: false, data: action.payload, error: null });
        case AO_PACKAGE_DETAILS_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        default:
            return state;
    }
};
export default addOrderPackageDetailsReducer;
